<script >
  // export let state;
  // export let showMsg;
  // export let clearMsg;

  import { onMount, afterUpdate } from "svelte";
  import { Button } from 'sveltestrap';
  import Dashboard from './Dashboard.svelte';
  import ReconWidget from './ReconWidget.svelte';
  import RecListWidget from './RecListWidget.svelte';
  import SettingsWidget from './SettingsWidget.svelte';
  import TabNav from './TabNav.svelte';
  import TabPanel from './TabPanel.svelte';
  import { from  } from './from';
  import { load, save, settings } from './settings';
  import { openRec, closeRec, createRec, store as recs, loadRecs } from './recs';
  import { hash, hashState } from './hash.js'
  
  let activeTabId = "dash", o;
  let lastRecListLength = 0;
  
  const staticTabs = [
    {id:"dash",     label:"Dashboard", closeable: false},
    {id:"settings", label:"Settings", icon: "cog", closeable: false},
  ]

  let initialRecsLoaded = false;

  load();
  loadRecs((cbrecs)=>{
    initialRecsLoaded=true;
    lastRecListLength = cbrecs.length;
    var prev = hash()["workspace"];
    if (prev && $recs.list.filter(r=>r.id == prev).shift()) {
      activeTabId = hash()["workspace"];
    }
      
  });

  // let uiprefs = (o = localStorage.getItem("uiprefs")) && JSON.parse(o);
  // console.log("Workspace.uiprefs", uiprefs)
  // if (uiprefs && uiprefs.workspace) {
  //   activeTabId = uiprefs.workspace.activeTabId;
  // } else {
  //   activeTabId = "dash";
  //   uiprefs = { workspace: { activeTabId: activeTabId } }; 
  //   localStorage.setItem("uiprefs", JSON.stringify(uiprefs));
  // }

$: {
  //console.log("Workspace.uiprefs $$ recs loaded?", initialRecsLoaded, activeTabId);
  
  // if (initialRecsLoaded) {

    if ($recs.list.length  > 0 && $recs.list.length !== lastRecListLength) {
      //console.log("Workspace.uiprefs $$  setting activeID", $recs.list[$recs.list.length-1].id)
      activeTabId = $recs.list[$recs.list.length-1].id;
      lastRecListLength = $recs.list.length;
    }

    // console.log("Workspace.uiprefs $$", activeTabId);
    // uiprefs.workspace.activeTabId = activeTabId; // XXX likely wrong and horrible, make it a store too, with auto persist?
    // localStorage.setItem("uiprefs", JSON.stringify(uiprefs));
}

var thisthis=this;
onMount(() => {
  //console.log("Workspace, onMount", $recs.list, activeTabId, thisthis)
})

afterUpdate(() => {
  //console.log("Workspace, afterupdate", $recs.list, activeTabId, thisthis)
  // activeTabId = activeTabId
})

</script>

<!-- <Button on:click={()=>$settings.modcount++}>{$settings.modcount} / {$settings.data.length}</Button> -->

<TabNav name="workspace" items={[staticTabs[0],...($recs.list.map(r=>({id:""+r.id,label:r.label,closeable:true}))), staticTabs[1]]} bind:activeTabId={activeTabId} closeTab={closeRec}>
  <div class="row pt-2">
    <div class="col-sm">
      <TabPanel tabId=dash     >
        <Dashboard settings={settings} recs={recs} />
      </TabPanel>
      <TabPanel tabId=recs  >
        <RecListWidget createRec={createRec} on:message />
      </TabPanel>
      <TabPanel tabId=settings >
        <SettingsWidget 
          bind:settings={$settings} 
          load={load} 
          save={save}
          recs={recs} 
          createRec={createRec}
          openRec={openRec} 
          on:message
          on:clear
          />
      </TabPanel>
      {#each $recs.list as rec}
      <TabPanel tabId={""+rec.id}   >
            <h4 class="text-center text-uppercase text-secondary mt-2 mb-0">{rec.name}</h4>
            <ReconWidget bind:settings={$settings} bind:rec={rec} on:message />
      </TabPanel>
      {/each}
    </div>
  </div>
</TabNav>
 
